import { render, staticRenderFns } from "./ActionButtonCompany.vue?vue&type=template&id=3facbcf9&"
import script from "./ActionButtonCompany.vue?vue&type=script&lang=js&"
export * from "./ActionButtonCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports